import {
  Box,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AppButton from "../../../components/AppButton";
import AppDialogHalfScreen from "../../../components/AppDialogHalfScreen";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cancelRecurringRule, getReccuringRules } from "../../../store/actions";
import AppScreenLoader from "../../../components/AppScreenLoader";
import { findSymbol, getSymbol } from "../../../utils";

export const RecurringDetailCard = ({ setActive, rules }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const symbols = useSelector(getSymbol);
  const account = useSelector(({ Auth }) => Auth?.account);
  
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleCancel = () => {
    setLoading(true);
    const success = () => {
      setLoading(false);
      dispatch(getReccuringRules())
      setShowConfirmation(false);
    }
    const failure = () => {
      setLoading(false);
      setShowConfirmation(false);
    }
    dispatch(cancelRecurringRule(rules.id, success, failure))
  }

  if(!rules) {
    return <AppScreenLoader />
  }
  const renderConfirmationPopUp = () => {
    return (
      <AppDialogHalfScreen
        show={showConfirmation}
        setShow={setShowConfirmation}
        title={t("Confirm")}
        subtitle={t("sureToCancelRecurring")}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-around"}
        >
          <AppButton
            buttontheme={"light"}
            title={t("No")}
            sx={{ width: 80, height: 40}}
            onClick={() => setShowConfirmation(false)}
          ></AppButton>
          <AppButton
            buttontheme={"success"}
            title={t("Yes")}
            sx={{ width: 80, height: 40}}
            loading={loading}
            onClick={handleCancel}
          ></AppButton>
        </Box>
      </AppDialogHalfScreen>
    );
  };

  return (
    <Card>
      {renderConfirmationPopUp()}
      <CardContent>
        <Grid container rowGap={5}>
          <Grid item xs={12}>
            <Typography variant="body1">{t("status")}</Typography>
            <Typography variant="body2" color={(rules.status === 1) ? "#0088F5" : '#DC2626'}>
              {rules.status === 1 && t('status.Active')}
              {rules.status === 0 && t('status.Pending')}
              {rules.status === -1 && t('status.Inactive')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">{t("recurring.threshold")}</Typography>
            <Typography variant="body2" color={"#0088F5"}>
              {findSymbol(symbols, account)}{rules.thresholdAmount}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">
              {t("recurring.cryptocurrency")}
            </Typography>
            <Typography variant="body2" color={"#0088F5"}>
              {rules.cryptoCurrency}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{t("network")}</Typography>
            <Typography variant="body2" color={"#0088F5"} textTransform={'capitalize'}>
            {rules.cryptoNetwork}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">{t("walletaddress")}</Typography>
            <Typography variant="body2" color={"#0088F5"}>
              {rules.walletAddress}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ display: "flex", justifyContent: "space-around" }}>
        {
          rules.status === 1? (
            <AppButton
              buttontheme={"light"}
              title={t("Cancel")}
              sx={{ width: 100, padding: 2, fontSize: 14, height: 20 }}
              onClick={() => setShowConfirmation(true)}
            ></AppButton>
          ) : null
        }
        <AppButton
          buttontheme={"light"}
          title={t("edit")}
          sx={{ width: 100, padding: 2, fontSize: 14, height: 20 }}
          onClick={() => setActive(1)}
        ></AppButton>
      </CardActions>
    </Card>
  );
};
